import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { MobileStickyCTA } from "./components/MobileStickyCTA";
import { CookieConsent } from "./components/CookieConsent";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Home } from "./pages/Home";
import { Services } from "./pages/Services";
import { Pricing } from "./pages/Pricing";
import { Landlords } from "./pages/Landlords";
import { Projects } from "./pages/Projects";
import { Rewiring } from "./pages/Rewiring";
import { RewireQuote } from "./pages/RewireQuote";
import { Extensions } from "./pages/Extensions";
import { NewBuildElectrician } from "./pages/NewBuildElectrician";
import { KitchenElectrician } from "./pages/KitchenElectrician";
import { About } from "./pages/About";
import { Reviews } from "./pages/Reviews";
import { Contact } from "./pages/Contact";
import { Privacy } from "./pages/Privacy";
import { Cookies } from "./pages/Cookies";
import { Terms } from "./pages/Terms";
import { CookieSettings } from "./pages/CookieSettings";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { AuthCallback } from "./components/AuthCallback";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check URL fragment for session_id synchronously during render
  // This prevents race conditions by processing new session_id FIRST before checking existing session_token
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<><Header /><Home /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/rewiring" element={<><Header /><Rewiring /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/services" element={<><Header /><Services /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/pricing" element={<><Header /><Pricing /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/projects" element={<><Header /><Projects /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/landlords" element={<><Header /><Landlords /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/about" element={<><Header /><About /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/contact" element={<><Header /><Contact /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/rewire-quote" element={<><Header /><RewireQuote /><Footer /><WhatsAppButton /></>} />
        <Route path="/house-rewiring" element={<><Header /><Rewiring /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/extensions" element={<><Header /><Extensions /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/renovation-electrics" element={<><Header /><Extensions /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/new-build-electrician" element={<><Header /><NewBuildElectrician /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/kitchen-electrician" element={<><Header /><KitchenElectrician /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/reviews" element={<><Header /><Reviews /><Footer /><MobileStickyCTA /><WhatsAppButton /></>} />
        <Route path="/privacy" element={<><Header /><Privacy /><Footer /></>} />
        <Route path="/cookies" element={<><Header /><Cookies /><Footer /></>} />
        <Route path="/terms" element={<><Header /><Terms /><Footer /></>} />
        <Route path="/cookie-settings" element={<><Header /><CookieSettings /><Footer /></>} />
        <Route path="/login" element={<Login />} />
        
        {/* Protected routes */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              {({ user }) => <Dashboard user={user} />}
            </ProtectedRoute>
          } 
        />
      </Routes>
      <Toaster />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
